/**
 * The rendered width of each COLUMN of a table, taken from one representative row.
 *
 * @param {HTMLTableElement} table
 * @returns {number[]} one entry per column, or `[]` for a table with no rows.
 */
export const measureColumnWidths = (table) => {
  let best = [];
  let bestCellCount = -1;

  Array.from(table.rows || []).forEach((row) => {
    const widths = [];

    Array.from(row.children).forEach((cell) => {
      const span = Math.max(cell.colSpan || 1, 1);
      const share = cell.getBoundingClientRect().width / span;

      for (let i = 0; i < span; i += 1) {
        widths.push(share);
      }
    });

    // Prefer the row with the most CELLS, not the most expanded entries: every row expands to the
    // full column count, but a merged cell can only be split EVENLY across the columns it covers,
    // so a full-width heading row would report equal columns for an unequal table. The least-merged
    // row is the one whose cells line up with real columns.
    if (row.children.length > bestCellCount) {
      bestCellCount = row.children.length;
      best = widths;
    }
  });

  return best;
};

export default measureColumnWidths;
